import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState({ plan: "free", status: "none", trial_end: null, current_period_end: null });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setStatus({ plan: "free", status: "none" }); return; }
    setLoading(true);
    try {
      const { data } = await http.get("/subscription/status");
      setStatus(data);
    } catch { /* keep last */ }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isPro = status?.plan === "pro";
  const inTrial = status?.status === "trialing";
  const daysLeft = status?.trial_end ? Math.max(0, Math.ceil((new Date(status.trial_end) - Date.now()) / 86_400_000)) : 0;

  return (
    <Ctx.Provider value={{ status, isPro, inTrial, daysLeft, loading, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export const useSubscription = () => useContext(Ctx);
